import { useQuery } from '@tanstack/react-query'
import { OpalApiRequestParams, OpalApiResponseDocument } from '@opallabs/api'
import { views } from '@opallabs/api/v3'
import { globalQueryKeys } from '../../queryKeys'

type ReadViewsResponse = OpalApiResponseDocument<'ReadViewsV3', 200>

type ViewsQuery = OpalApiRequestParams<'ReadViewsV3'>['query']

type UseReadViewsParams = {
  filter: OpalApiRequestParams<'ReadViewsV3'>['query']['filter']
  workspaceUuid: string
}

type UseReadViewsOptions<T = ReadViewsResponse> = UseReadViewsParams & {
  select?: (data: ReadViewsResponse) => T
}

export const useReadViews = <T = ReadViewsResponse>({
  filter,
  select,
  workspaceUuid,
}: UseReadViewsOptions<T>) => {
  const query: ViewsQuery = {
    filter,
  }

  return useQuery({
    queryKey: globalQueryKeys.viewsByWorkspace(workspaceUuid, query),
    queryFn: () =>
      views.readCollection({
        params: {
          query,
        },
      }),
    select,
  })
}
